<template>
  <svg :width="size" :height="size" viewBox="0 0 10 6"
       fill="none" xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.24604 0.149583C4.50789 -0.0639836 4.89389 -0.0489211 5.13797 0.195156L9.13797 4.19516C9.39832 4.45551 9.39832 4.87752 9.13797 5.13786C8.87762 5.39821 8.45561 5.39821 8.19526 5.13786L4.66662 1.60922L1.13797 5.13786C0.877621 5.39821 0.455612 5.39821 0.195262 5.13786C-0.0650874 4.87752 -0.0650874 4.45551 0.195262 4.19516L4.19526 0.195156L4.24604 0.149583Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'ChevronTopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 12,
    },
    fill: {
      type: String,
      default: '#8A8D93',
    },
  },
};
</script>